import { axios } from '@/utils/request'
import qs from 'qs'

let moduleName = 'yearWork'

export function selectAll(parameter) {
  console.log('params:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectOne(accountId,year) {
  console.log('id:', accountId,year)
  return axios({
    url: `/ws/${moduleName}/${accountId}/${year}`,
    method: 'get'
  })
}

export function getYearSalary(accountId,year) {
  console.log('id:', accountId,year)
  return axios({
    url: `/ws/${moduleName}/getYearSalary/${accountId}/${year}`,
    method: 'get'
  })
}

export function update(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data: parameter
  })
}

export function saveYearTarget(parameter) {
  console.log('data:', parameter)
  return axios({
    url: `/ws/${moduleName}/saveYearTarget`,
    method: 'post',
    data: parameter
  })
}


export function deleteYearTarget(ids) {
  console.log('ids', ids)
  return axios({
    url: `/ws/${moduleName}/deleteYearTarget`,
    method: 'delete',
    params: ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export default {
  selectAll,
  selectOne,
  getYearSalary,
  update,
  saveYearTarget,
  deleteYearTarget,
}